import React from 'react';
import { bionicText } from '../../../../utils/bionicText';

const Footer = ({ bionicEnabled, copyright }) => (
  <footer className="landing-footer">
    <div className="footer-content">
      <div className="footer-section" key="footer-section">
        <h4 key="footer-title">{bionicEnabled ? bionicText('Yes Boss') : 'Yes Boss'}</h4>
        <p key="footer-subtitle">{bionicEnabled ? bionicText('People powered by people') : 'People powered by people'}</p>
      </div>
    </div>
    <div className="footer-bottom" key="footer-bottom">
      <p key="footer-copyright">{bionicEnabled ? bionicText(copyright) : copyright}</p>
    </div>
  </footer>
);

export default React.memo(Footer);
